import { render, staticRenderFns } from "./ThreeDSDeviceCollectionPage.vue?vue&type=template&id=6e84bae0&"
import script from "./ThreeDSDeviceCollectionPage.vue?vue&type=script&lang=js&"
export * from "./ThreeDSDeviceCollectionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e84bae0')) {
      api.createRecord('6e84bae0', component.options)
    } else {
      api.reload('6e84bae0', component.options)
    }
    module.hot.accept("./ThreeDSDeviceCollectionPage.vue?vue&type=template&id=6e84bae0&", function () {
      api.rerender('6e84bae0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ThreeDSDeviceCollectionPage.vue"
export default component.exports